import { TieOutPage } from '@/pages/shared/tie-out';

export function TradingTieOutPage() {
  return <TieOutPage app="TRADING" />;
}
